export default {
  REGISTER_ELEMENT: 'REGISTER_ELEMENT',
  CHANGE_ACTIVE_NAV_ITEM: 'CHANGE_ACTIVE_NAV_ITEM',
  DESELECT_ALL: 'DESELECT_ALL',
};
